class EventHandler {
  constructor() {
    this.emit = (event, data) => {
      this.resolveEvent(event, data)
    }
  }
  async resolveEvent(event, data = null) {
    const res = !__._event.resolve ? _$.log("Library event resolver is not found.", false) : await __._event.resolve(event, data)

    if (!res || !res.name) return

    res.data ? _$.log(`Event resolved => ${res.name} | ${JSON.stringify(res.data)}`) : _$.log(`Event resolved => ${res.name}`)

    res.data = {
      detail: res.data,
      type: res.name
    }

    this.releaseEvent(res.name, res.data)
    return true
  }
  async releaseEvent(name, data = {}) {
    return _$.vue.$emit(name, data)
  }
}

export default new EventHandler()
